import { NavLink } from "react-router-dom";
import { routePaths } from "../constants/routes";
import {
  monetizationBenefits,
  premiumPdfCategories,
  premiumStoreSteps,
} from "../content/premiumNotesCatalog";
import "../style/premium-notes-store.css";

export default function PremiumNotesStore() {
  const featured = premiumPdfCategories[0];

  return (
    <main className="premium-store-page">
      <section className="premium-store-hero">
        <div className="premium-store-copy">
          <span className="premium-store-kicker">QACoder Premium PDFs / eBooks</span>
          <h1>Low-ticket digital products built for QA learners and job seekers</h1>
          <p>
            Turn QACoder traffic into a strong monetization channel with topic-wise PDF products:
            basic to advanced notes, real-time examples, interview preparation, and project-ready packs.
          </p>

          <div className="premium-store-cta-row">
            <NavLink to={featured.to} className="premium-store-primary">
              Explore JIRA Pack
            </NavLink>
            <NavLink to={routePaths.studyNotes} className="premium-store-secondary">
              Back to Study Notes
            </NavLink>
          </div>
        </div>

        <div className="premium-store-highlight">
          <div>
            <strong>8 PDF product ideas</strong>
            <span>From fresher notes to job-ready QA document packs</span>
          </div>
          <div>
            <strong>Best starting point</strong>
            <span>JIRA for QA Engineers with preview, checkout, and printable unlock flow</span>
          </div>
        </div>
      </section>

      <section className="premium-store-section">
        <div className="premium-store-heading">
          <span>Featured live product</span>
          <h2>Start with one polished pack, then expand category by category</h2>
        </div>

        <article className="premium-feature-card">
          <div className="premium-feature-copy">
            <div className="premium-badge-live">Live product</div>
            <h3>{featured.title}</h3>
            <p>{featured.highlight}</p>
            <ul>
              <li>Level: {featured.level}</li>
              <li>Target students: {featured.target}</li>
              <li>Suggested price band: {featured.price}</li>
            </ul>
          </div>

          <div className="premium-feature-panel">
            <strong>Why this should sell first</strong>
            <p>
              JIRA is relevant for freshers, manual testers, automation testers, and interview candidates.
              It also supports a clear preview-to-purchase flow with tables, bug templates, Agile concepts,
              JQL, dashboards, and enterprise interview questions.
            </p>
            <NavLink to={featured.to} className="premium-store-primary">
              Open Premium JIRA Pack
            </NavLink>
          </div>
        </article>
      </section>

      <section className="premium-store-section">
        <div className="premium-store-heading">
          <span>Product catalog roadmap</span>
          <h2>Paid PDF categories you can grow into a serious digital store</h2>
        </div>

        <div className="premium-grid">
          {premiumPdfCategories.map((item) => (
            <article className="premium-product-card" key={item.id}>
              <div className={`premium-product-status premium-product-status-${item.status.toLowerCase()}`.trim()}>
                {item.status}
              </div>
              <h3>{item.title}</h3>
              <p>{item.highlight}</p>
              <div className="premium-meta-list">
                <span>Level: {item.level}</span>
                <span>Target: {item.target}</span>
                <span>Price: {item.price}</span>
              </div>
              {item.to ? (
                <NavLink to={item.to} className="premium-inline-link">
                  View Product
                </NavLink>
              ) : (
                <span className="premium-inline-link disabled">Coming soon</span>
              )}
            </article>
          ))}
        </div>
      </section>

      <section className="premium-store-section premium-store-two-col">
        <article className="premium-info-card">
          <span>Why this monetization works</span>
          <h2>Use paid PDFs as a strong entry-level revenue layer</h2>
          <ul>
            {monetizationBenefits.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>

        <article className="premium-info-card">
          <span>Recommended flow</span>
          <h2>Simple funnel for QACoder premium notes</h2>
          <ol>
            {premiumStoreSteps.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
        </article>
      </section>

      <section className="premium-store-section">
        <div className="premium-store-bottom-cta">
          <div>
            <span>Next expansion</span>
            <h2>After JIRA, API Testing and Manual Testing PDFs should be your next paid launches</h2>
            <p>
              Those two products match your current content library best and can reuse the same premium preview,
              checkout, and printable access model already available on the site.
            </p>
          </div>
          <NavLink to={routePaths.jiraNotes} className="premium-store-primary">
            Review Live Monetization Example
          </NavLink>
        </div>
      </section>
    </main>
  );
}
